// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp, setTransactionData } from "_core/slices/datas/TransactionSlice";

// 運営ツールの応答に含まれる表示設定画面用の情報 → redux のキー
const TRANSACTION_KEYS = {
    t_appearance_list: "tAppearanceList",
    t_asset_list: "tAssetList",
    t_user_add: "tUserAdd",
    t_user: "tUser",
};

/**
 * 運営ツールAPIの共通実行
 * 表示設定画面（getAssetInfo）やメニュー（レポート表示判定）が古い redux の値を読まないよう、
 * 応答に含まれる見た目・アセット・ユーザー追加情報を redux に反映する。
 * @returns {Promise<{response, error}>}
 */
export const ExecOpsRequest = async (dispatch, { url, requestParams = {}, requestBinaryParams = {}, timeout, onUploadProgress = null }) => {
    let response = null;
    let error = null;
    try {
        response = await ApiRequest({ url, requestParams, requestBinaryParams, timeout, onUploadProgress });
    } catch (e) {
        error = e;
    }

    if (response !== null && response.error_code === 0) {
        dispatch(setApiTimestamp(response['now_time']));
        const transactionData = {};
        Object.entries(TRANSACTION_KEYS).forEach(([responseKey, stateKey]) => {
            if (response[responseKey] != null) {
                transactionData[stateKey] = response[responseKey];
            }
        });
        if (Object.keys(transactionData).length) {
            dispatch(setTransactionData(transactionData));
        }
    }
    return { response, error };
};

// 動画アップロードの待ち時間上限(ms)
export const OPS_UPLOAD_TIMEOUT = 60 * 60 * 1000;
